import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { FujiSilhouette } from "./JapaneseMotifs";

export function Footer() {
  const { t } = useLang();
  return (
    <footer className="relative bg-deepsea text-white pt-28 pb-20 overflow-hidden" data-testid="footer">
      <FujiSilhouette className="absolute top-0 left-1/2 -translate-x-1/2 w-[720px] max-w-none text-ice opacity-[0.08] pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-2.5">
              <img src="/logo-white.png" alt="2D Healthcare" className="h-8 w-auto object-contain" />
              <div className="font-heading font-bold tracking-tight">2D Healthcare</div>
            </div>
            <p className="mt-4 text-sm text-white/50 leading-relaxed max-w-xs">{t("footer_tag")}</p>
          </div>
          <div className="space-y-3 text-sm text-white/70">
            <div className="flex items-center gap-3"><Mail size={15} className="text-white/40" /> info@2dhealthcare.com</div>
            <div className="flex items-center gap-3"><Phone size={15} className="text-white/40" /> +90 538 541 11 02 · +90 531 670 24 60</div>
            <div className="flex items-start gap-3"><MapPin size={15} className="text-white/40 mt-0.5" /> <span>Küçük Çamlıca Mah. Vefakar Sok. No:1, 34696 Üsküdar / İstanbul</span></div>
            <a
              href="https://www.google.com/maps?hl=tr&mat=CRRRtjsCvacmElcBa0lj_x6n8JU_O_CkGNrP2sLk8j4Z3xFPWW5snjAaEoacEpptTl62QjcPkqmBimrrAXGuYofgnmD7_i62hK5iRbIm_68isNTvuOo9xAdKJ88o6U8Df6g&um=1&ie=UTF-8&fb=1&gl=tr&sa=X&geocode=KRmK_JlgycoUMbFd0yNyRgO-&daddr=K%C3%BC%C3%A7%C3%BCk+%C3%87aml%C4%B1ca,+VEFAKAR+SOK+No:1,+34696+%C3%9Csk%C3%BCdar/%C4%B0stanbul"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-google-maps-link"
              className="mt-2 inline-flex items-center gap-2.5 self-start rounded-full bg-white/10 hover:bg-white/15 border border-white/15 px-4 py-2 text-xs font-semibold text-white transition-colors"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4" aria-hidden="true"><path fill="#4285F4" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/><circle fill="#fff" cx="12" cy="9" r="2.5"/></svg>
              {t("footer_maps")}
            </a>
            <a
              href="https://www.linkedin.com/in/japonyada-kanser-tedavisi-2d-3a1143408/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin-link"
              className="inline-flex items-center gap-2.5 self-start rounded-full bg-white/10 hover:bg-white/15 border border-white/15 px-4 py-2 text-xs font-semibold text-white transition-colors"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4" aria-hidden="true"><path fill="#0A66C2" d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.94v5.67H9.36V9h3.41v1.56h.05c.47-.9 1.63-1.85 3.36-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.55V9h3.57v11.45z"/></svg>
              LinkedIn
            </a>
          </div>
          <div className="flex flex-col gap-2.5 text-sm">
            <Link to="/belgeler" data-testid="footer-docs-link" className="text-white/70 hover:text-white transition-colors">{t("nav_documents")}</Link>
            <Link to="/teknoloji" data-testid="footer-tech-link" className="text-white/70 hover:text-white transition-colors">{t("footer_tech")}</Link>
            <Link to="/zarafet" data-testid="footer-zarafet-link" className="text-white/70 hover:text-white transition-colors">{t("footer_zarafet")}</Link>
            <Link to="/panel" data-testid="footer-portal-link" className="text-white/70 hover:text-white transition-colors">{t("nav_portal")}</Link>
            <Link to="/giris" data-testid="footer-login-link" className="text-white/70 hover:text-white transition-colors">{t("nav_login")}</Link>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4">
          <p className="text-[11px] text-white/35 max-w-2xl leading-relaxed">{t("footer_disclaimer")}</p>
          <p className="text-[11px] text-white/35 shrink-0">© 2026 2D Healthcare · {t("footer_rights")}</p>
        </div>
        <p className="mt-4 text-[11px] text-white/30">2D Healthcare — a Diagenics Ar-Ge Ltd. Şti. company</p>
      </div>
    </footer>
  );
}
